import { useEffect, useLayoutEffect } from 'react';

/**
 * 페인트 **전에** 부모로 상태를 올려야 할 때 쓴다.
 * useEffect 로 올리면 등록 전 값(예: 폭 0)으로 한 프레임이 먼저 그려져 레이아웃이 번쩍인다.
 *
 * 서버에는 레이아웃 단계가 없어 useLayoutEffect 가 경고를 내므로 SSR 에서는 useEffect 로 내린다.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
